import * as ACTION from '../constants/types/dashboardTypes';
import { packageReq } from '../helpers/request';
import { packageDBReq } from '../deconstructionCenter/dashboardApi';

// 获取新手任务
export function getUserTask(callback) {
  var dbpayload = packageDBReq(ACTION.GET_USER_TASK, null, null, 'GET', false);
  return {
    type: ACTION.GET_USER_TASK,
    dbpayload,
    pick: ['card', 'charge', 'bet', 'percent', 'task_prize->prize', 'Schedule->schedule'],
    callback
  }
}

// 获取团队管理首页信息
export function getTeamUserList({ username, userId, pageNo, orderBy, sortBy} = {}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.DASH_GET_TEAMUSER_LIST, [username, userId, pageNo, orderBy, sortBy], null, 'GET', loading);
  return {
    type: ACTION.DASH_GET_TEAMUSER_LIST,
    dbpayload,
    node: 'view',
    pick: ['bread', 'users', 'isshow->canRecharge', 'user'],
    callback
  }
}

// 设置下级返点
export function setFollwerRebet(postData, {loading = { text: '返点提交中...' }} = {}, callback) {
  const data = { flag: 'rapid', ...postData };
  var dbpayload = packageDBReq(ACTION.DASH_SET_FOLLWER_REBET, null, data, 'POST', loading);
  return {
    type: ACTION.DASH_SET_FOLLWER_REBET,
    dbpayload,
    pick: ['msg_type->status', 'msg_detail->message'],
    callback
  }
}

// 设置下级返点 新版接口 支持恒系/9系
export function setFollwerRebetNew(postData, callback) {   
  var payload = packageReq(ACTION.DASH_SET_FOLLWER_REBET_NEW, null, postData, 'PUT');
  return {
    type: ACTION.DASH_SET_FOLLWER_REBET_NEW,
    payload,
    _callbacks_: [callback]   
  }
}


// 获取账变记录
export function getAccountCR({ userid, starttime, endtime, ordertype, status, pageNo} = {}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_ACCOUNT_CR, [userid, starttime, endtime, ordertype, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_ACCOUNT_CR,
    dbpayload,
    node: 'accountCR',
    pick: ['icount->summary', 'orders'],
    callback
  }
}

// 获取彩种关联关系
export function getLotteryMethod(callback) {
  var dbpayload = packageDBReq(ACTION.GET_LOTTERY_METHOD, null, null, 'GET', false, 1 / 24);
  return {
    type: ACTION.GET_LOTTERY_METHOD,
    pick: ['lotteryList', 'newMethodList->methodList'],
    dbpayload,
    callback
  }
}

// 获取投注记录
export function getBetRecord({username, starttime, endtime, lotteryid, methodid, isgetprizestatus, ischild, pageNo, device} ={}, {loading = true} = {}, callback){
  var dbpayload = packageDBReq(ACTION.GET_BET_RECORD, [username, starttime, endtime, lotteryid, methodid, isgetprizestatus,ischild, pageNo,device], null, 'GET', loading);
  return {
    type: ACTION.GET_BET_RECORD,
    dbpayload,
    pick: ['aProject->list','total'],
    node: 'bets',
    callback
  }
}

// 获取真人电子投注记录
export function getBetRecordForCasino({ userid, starttime, endtime, platform, pageNo} = {}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_BET_RECORD_FOR_CASINO, [userid, starttime, endtime, platform, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_BET_RECORD_FOR_CASINO,
    dbpayload,
    pick: ['aProject->list'],
    node: 'bets',
    callback
  }
}

// 获取详情，通过回调函数设置，不经过reducer
export function getBetDetail({ id} = {}, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_BET_DETAIL, [id], null, 'GET', loading);
  return {
    type: ACTION.GET_BET_DETAIL,
    dbpayload,
    callback,
    pick: ['project->detail', 'lottery->name', 'method', 'nocode', 'is_cancelable']
  }
}

// 撤单
export function cancelBet({ id} = {}, { loading = '撤单中...'} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.CANCEL_BET, [id], null, 'GET', loading);
  return {
    type: ACTION.CANCEL_BET,
    dbpayload,
    callback,
    pick: ['msg_type->status', 'msg_detail->message']
  }
}

// 检查开户用户名
export function checkUsername({ username}, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.CHECK_USERNAME, [username], null, 'GET', loading);
  return {
    type: ACTION.CHECK_USERNAME,
    dbpayload,
    callback,
    pick: ['status']
  }
}

// 开户
export function addUser(data, { loading = { text: '开户中...' }} = {}, callback) {
  const postData = _.merge({ flag: 'insert'}, { ...data });
  var dbpayload = packageDBReq(ACTION.ADD_USER, null, postData, 'POST', loading);
  return {
    type: ACTION.ADD_USER,
    dbpayload,
    callback,
    pick: ['msg_type->status', 'msg_detail->message']
  }
}

// 获取推广链接
export function getPromotionLink(callback) {
  var dbpayload = packageDBReq(ACTION.GET_PROMOTION_LINK, null, null, 'GET');
  return {
    type: ACTION.GET_PROMOTION_LINK,
    dbpayload,
    callback,
    pick: ['links', 'maxPoint', 'selectedPoint->currentPoint', 'domainList->domains', 'prizeGroups->rebets']
  }
}

// 设置推广链接返点
export function setPromotionLink({
  point,
  livepoint,
  sportpoint,
  esportspoint,
  withoutResize,
  pokerpoint, 
  qqs=[], 
  emails=[]
} = {}, {loading = {text: '保存更新中'}} ={}, callback){
  var dbpayload = packageDBReq(ACTION.SET_PROMOTION_LINK, null, {
    point, 
    livepoint,
    sportpoint,
    esportspoint,
    withoutResize,
    pokerpoint,
    qqs,
    emails
  }, 'POST', loading);
  return {
    type: ACTION.SET_PROMOTION_LINK,
    dbpayload,
    callback,
    pick: ['sMsg->message']
  }
}

// 团队统计
export function getTeamStatistics({ start, end} = {}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_TEAM_STATISTICS, [start, end], null, 'GET', loading);
  return {
    type: ACTION.GET_TEAM_STATISTICS,
    dbpayload,
    callback,
    pick: ['summary', 'summaryExt', 'chart', 'isContractUser']
  }
}


// 获取日工资数据
export function getDailyWages({ orderBy, sortBy, starttime, endtime, status, pageNo}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_DAILY_WAGES, [orderBy, sortBy, starttime, endtime, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_DAILY_WAGES,
    dbpayload,
    callback,
    pick: ['contract', 'total->total_sum', 'count->page_sum', 'data->list', 'chineseNum->chinese', 'description', 'unit', 'is_auto_fill_wage_contract'],
    node: 'daily_wage'
  }
}

// 获取真人反水数据
export function getCasinoCompact({ orderBy, sortBy, starttime, endtime, status, pageNo}, {loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_CASINO_COMPACT, [orderBy, sortBy, starttime, endtime, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_CASINO_COMPACT,
    dbpayload,
    callback,
    pick: ['contract', 'total->total_sum', 'count->page_sum', 'data->list', 'chineseNum->chinese','prompt->tips'],
    node: 'casino_compact'
  }
}

// 获取体育反水数据
export function getSportCompact({orderBy, sortBy, starttime, endtime, status, pageNo}, {loading = true} ={}, callback){
  var dbpayload = packageDBReq(ACTION.GET_SPORT_COMPACT, [orderBy, sortBy, starttime, endtime, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_SPORT_COMPACT,
    dbpayload,
    callback,
    pick: ['contract', 'total->total_sum', 'count->page_sum', 'data->list', 'chineseNum->chinese','prompt->tips'],
    node: 'sport_compact'
  }
}

// 获取kgame反水数据
export function getKgameCompact({ orderBy, sortBy, starttime, endtime, status, pageNo}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_KGAME_COMPACT, [orderBy, sortBy, starttime, endtime, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_KGAME_COMPACT,
    dbpayload,
    callback,
    pick: ['contract', 'total->total_sum', 'count->page_sum', 'data->list', 'chineseNum->chinese','description'],
    node: 'kgame_compact'
  }
}

// 获取电竞反水数据
export function getESportsCompact({ orderBy, sortBy, starttime, endtime, status, pageNo}, { loading = true } = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_ESPORTS_COMPACT, [orderBy, sortBy, starttime, endtime, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_ESPORTS_COMPACT,
    dbpayload,
    callback,
    pick: ['contract', 'total->total_sum', 'count->page_sum', 'data->list', 'chineseNum->chinese','prompt->tips'],
    node: 'esports_compact'
  }
}
// 获取棋牌反水数据
export function getPorkerCompact({ orderBy, sortBy, starttime, endtime, status, pageNo}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_PORKER_COMPACT, [orderBy, sortBy, starttime, endtime, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_PORKER_COMPACT,
    dbpayload,
    callback,
    pick: ['contract', 'total->total_sum', 'count->page_sum', 'data->list', 'chineseNum->chinese','prompt->tips'],
    node: 'porker_compact'
  }
}

// 获取棋牌反水数据
export function getChessCompact({orderBy, sortBy, starttime, endtime, status, pageNo}, {loading = true} ={}, callback){
  var dbpayload = packageDBReq(ACTION.GET_CHESS_COMPACT, [orderBy, sortBy, starttime, endtime, status, pageNo], null, 'GET', loading);
  return {
		type: ACTION.GET_CHESS_COMPACT,
    dbpayload,
    callback,
    pick: ['contract', 'total->total_sum', 'count->page_sum', 'data->list', 'chineseNum->chinese','description'],
    node: 'chess_compact'
  }
}

// 获取下级契约
export function getTeamContract({username, status, pageNo, type,userId}, {loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_TEAM_CONTRACT, [type, username,userId, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_TEAM_CONTRACT,
    dbpayload,
    callback,
    pick: ['data->list', 'bread', 'children', 'unit','interval', 'setRules->rules'],
    node: 'team_contract'
  }
}

// 创建契约
export function createContract({min_bet, min_player, loss_amount, ratio, users, type}, {loading = true} = {}, callback){
  const data = { min_bet, min_player, loss_amount, ratio, users, tag: 'create' }
  switch(type){
    case 'teamcompact': type=1; break;
    case 'teamcompactlive': type=2; break;
    case 'teamcompactsport': type=3; break;
    case 'teamcompactpoker': type=4; break;
    case 'teamcompactxy': type=5; break;
    case 'teamcompactesports': type=5; break;
    case 'teamcompactkg': type=6; break;
  }
  var dbpayload = packageDBReq(ACTION.CREATE_CONTRACT, [type], data, 'POST', loading);
  return {
    type: ACTION.CREATE_CONTRACT,
    dbpayload,
    callback,
    pick: ['msg_detail->errorMessage', 'msg_type->status', 'sMsg->message']
  }
}

// 棋牌创建契约
export function createContractXy({ min_bet, min_player, loss_amount, ratio, users, type}, { loading = true} = {}, callback) {
  const data = { min_bet, min_player, loss_amount, ratio, users, tag: 'create'}
  switch(type){
    case 'teamcompact': type=1; break;
    case 'teamcompactlive': type=2; break;
    case 'teamcompactsport': type=3; break;
    case 'teamcompactpoker': type=4; break;
    case 'teamcompactxy': type=5; break;
    case 'teamcompactesports': type=5; break;
    case 'teamcompactkg': type=6; break;
  }
  var dbpayload = packageDBReq(ACTION.CREATE_CONTRACT_XY, [type], data, 'POST', loading);
  return {
    type: ACTION.CREATE_CONTRACT_XY,
    dbpayload,
    callback,
    pick: ['msg_detail->errorMessage', 'msg_type->status', 'sMsg->message']
  }
}

// 更新契约
export function updateContract({min_bet, min_player, loss_amount, ratio, users, type}, {loading = true} = {}, callback){
  const data = {min_bet, min_player, loss_amount, ratio, users, tag: 'upgrade', flag: 'modify' }
  switch(type){
    case 'teamcompact': type=1; break;
    case 'teamcompactlive': type=2; break;
    case 'teamcompactsport': type=3; break;
    case 'teamcompactpoker': type=4; break;
    case 'teamcompactxy': type=5; break;
    case 'teamcompactesports': type=5; break;
    case 'teamcompactkg': type=6; break;
  }
  var dbpayload = packageDBReq(ACTION.UPDATE_CONTRACT, [type], data, 'POST', loading);
  return {
    type: ACTION.UPDATE_CONTRACT,
    dbpayload,
    callback,
    pick: ['msg_detail->errorMessage', 'msg_type->status', 'sMsg->message']
  }
}

// 获取下级时薪
export function getTeamWages({orderBy, sortBy, starttime, endtime, status, username, pageNo, type,userId }, {loading = true} = {}, callback){
  var dbpayload = packageDBReq(ACTION.GET_TEAM_WAGE, [type, orderBy, sortBy, username,userId, starttime, endtime, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_TEAM_WAGE,
    dbpayload,
    callback,
    pick: ['data->list', 'total->total_sum', 'bread', 'count->page_sum','prompt->tips'],
    node: 'team_wage'
  }
}

// 获取真人电子体育报表
export function getEprofitLoss({ orderBy, sortBy, starttime, endtime, cid, username, userid, pageNo}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_EPROFITLOSS, [orderBy, sortBy, userid, username, starttime, endtime, cid, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_EPROFITLOSS,
    dbpayload,
    callback,
    pick: ['aProfitLoss->list', 'totalCount->total_sum', 'pageCount->page_sum', 'aSelf->self', 'bread', 'isShowWages->showWage', 'fromgameArr->gameArr'],
    node: 'eprofit_loss'
  }
}

// 获取日亏损报表
export function getDailyLoss({ username, starttime, endtime, status, pageNo}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_DAILY_LOSS, [username, starttime, endtime, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_DAILY_LOSS,
    dbpayload,
    callback,
    pick: ['lists->list', 'pageCnt->pageCount', 'allCnt->totalCount'],
    node: 'daily_loss'
  }
}

// 获取月亏损报表
export function getMonthLoss({ username, starttime, endtime, status, pageNo}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_MONTH_LOSS, [username, starttime, endtime, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_MONTH_LOSS,
    dbpayload,
    callback,
    pick: ['lists->list', 'sMsg->msg' ,'pageCnt->pageCount', 'allCnt->totalCount'],
    node: 'month_loss'
  }
}

// 获取彩票报表
export function getLotteryReport({ orderBy, sortBy, userId, starttime, endtime, username, type, pageNo}, { loading = true} = {}, callback) {
  endtime = $.momentDate(endtime).add(-1, 'minutes').format('YYYY-MM-DD HH:mm')
  var dbpayload = packageDBReq(ACTION.GET_LOTTERY_REPORT, [orderBy, sortBy, userId, starttime, endtime, username, type, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_LOTTERY_REPORT,
    dbpayload,
    callback,
    pick: ['result->data', 'bread', 'isContractUser', 'msg_type->status', 'msg_detail->message', 'dateDayCount', 'mobile_page->mobilePage'],
    node: 'lottery_report'
  }
}

// 获取彩票账变信息
export function getLotteryCR({ userid, starttime, endtime, lotteryid, ordertype, pageNo}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_LOTTERY_CR, [userid, starttime, endtime, lotteryid, ordertype, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_LOTTERY_CR,
    dbpayload,
    callback,
    pick: ['aOrders->orders'],
    node: 'lotteryCR'
  }
}

// 获取彩票追号信息
export function getTracks({ starttime, endtime, lotteryid, methodid, pageNo}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_TRACKS, [starttime, endtime, lotteryid, methodid, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_TRACKS,
    dbpayload,
    callback,
    pick: ['list', 'total_sum', 'username'],
    node: 'tracks'
  }
}

// 获取追号详情
export function getTrackDetail({ id}, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_TRACK_DETAIL, [id], null, 'GET', loading);
  return {
    type: ACTION.GET_TRACK_DETAIL,
    dbpayload,
    callback,
    pick: ['task->detail', 'aTaskdetail->list', 'can->is_cancelable']
  }
}

// 停止追号
export function stopTrack({ id, issues}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.STOP_TRACKS, null, { id, taskid: issues }, 'POST', loading);
  return {
    type: ACTION.STOP_TRACKS,
    dbpayload,
    callback,
    pick: ['msg_type->status', 'msg_detail->message']
  }
}

// 修改密码
export function changeLoginPass(data, { loading = true}, callback) {
  var dbpayload = packageDBReq(ACTION.CHANGE_LOGIN_PASSWORD, null, data, 'POST', loading);
  return {
    type: ACTION.CHANGE_LOGIN_PASSWORD,
    dbpayload,
    callback,
    pick: ['msg_type->status', 'msg_detail->message']
  }
}

// 获取转账信息
export function getTransferRecord({ starttime, endtime, out_money, in_money, status, pageNo}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_TRANSFER_RECORD, [starttime, endtime, out_money, in_money, status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_TRANSFER_RECORD,
    dbpayload,
    pick: ['allTransferInfoList->list'],
    node: 'transfer',
    callback
  }
}

// 验证密保问题
export function checkSecQA(data, { loading = true} = {}, callback) {
  data = {
    nextcon: 'user',
    nextact: 'bindsequestion',
    flag: 'check',
    ...data
  }
  var dbpayload = packageDBReq(ACTION.CHECK_SEC_QA, null, data, 'POST', loading);
  return {
    type: ACTION.CHECK_SEC_QA,
    dbpayload,
    callback,
    pick: ['sMsg->message', 'status', 'data']
  }
}

// 设置提款密码
export function setSecPassByToken(data, { loading = true, rsa = false} = {}, callback) {
  data = {
    flag: "gener",
    newsecpass: rsa ? data.pwd : $.Hex_MD5(data.pwd),
    ...data
  }
  var dbpayload = packageDBReq(ACTION.SET_SEC_PASS, null, data, 'POST', loading);
  return {
    type: ACTION.SET_SEC_PASS,
    dbpayload,
    callback,
    pick: ['sMsg->message', 'msg_type->status', 'msg->message', 'status']
  }
}

// 验证提款密码
export function checkoutSecPass({ securityPass, code}, { loading = true} = {}, callback) {
  const data = {
    flag: 'check',
    nextcon: 'user',
    nextact: 'userbankinfo',
    secpass: securityPass,
    code
  };
  var dbpayload = packageDBReq(ACTION.CHECK_SEC_PASS, null, data, 'POST', loading);
  return {
    type: ACTION.CHECK_SEC_PASS,
    dbpayload,
    pick: ['msg_type->error', 'status', 'msg_detail->errorMsg', 'msg->message'],
    callback
  };
}


// 获取银行信息
export function getBankInfo({ checkcode}, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_BANK_INFO, [checkcode], null, 'GET', loading);
  return {
    type: ACTION.GET_BANK_INFO,
    dbpayload,
    pick: ['banklist', 'has_phone', 'num->maxBind', 'binded', 'phone_number', 'data->isBindCard'],
    node: 'bindedinfo',
    callback
  };
}

// 锁定银行卡
export function lockBankCard({ bankId}, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.LOCK_BANK_CARD, [bankId], null, 'GET', loading);
  return {
    type: ACTION.LOCK_BANK_CARD,
    dbpayload,
    pick: ['msg_type', 'msg_detail'],
    callback
  };
}

// 获取绑定银行卡信息
export function getBankCard({ loading = false} = {}) {
  var dbpayload = packageDBReq(ACTION.ADD_BANK_CARD, null, null, 'GET', loading);
  return {
    type: ACTION.ADD_BANK_CARD,
    dbpayload,
    pick: ['msg_type', 'msg_detail', 'flag', 'banklist', 'provincelist'],
    node: 'addbankinfo'
  };
}

// 获取城市
export function getBankCity(data, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.ADD_BANK_CARD, null, data, 'POST', loading);
  return {
    type: ACTION.ADD_BANK_CARD,
    dbpayload,
    pick: ['city'],
    node: 'getcity',
    callback
  };
}

// 绑定银行卡
export function addBankCard(data, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.ADD_BANK_CARD, null, data, 'POST', loading);
  return {
    type: ACTION.ADD_BANK_CARD,
    dbpayload,
    pick: data.flag == 'checkLastBank' ? ['msg_type', 'msg_detail', 'flag', 'banklist', 'provincelist'] : ['msg_type', 'msg_detail', 'flag', 'nickname'],
    node: data.flag == 'checkLastBank' ? 'addbankinfo' : 'confirmbankinfo',
    callback
  };
}

// 检查重新绑定银行卡
export function reCheckBankCard({ bankId}, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.REBIND_BANK_CARD, [bankId], null, 'GET', loading);
  return {
    type: ACTION.REBIND_BANK_CARD,
    dbpayload,
    pick: ['msg_type', 'msg_detail', 'flag', 'action'],
    callback
  };
}

// 重新绑定银行卡
export function reBindBankCard(data, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.REBIND_BANK_CARD, [data.id], data, 'POST', loading);
  return {
    type: ACTION.REBIND_BANK_CARD,
    dbpayload,
    pick: ['msg_type', 'msg_detail', 'flag', 'banklist', 'provincelist'],
    node: 'addbankinfo',
    callback
  };
}

// 检查手机号
export function checkPhoneNumber(phonenumber, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.CHECK_PHONE_NUMBER, null, {
    phonenumber: phonenumber
  }, 'POST', loading);
  return {
    type: ACTION.CHECK_PHONE_NUMBER,
    dbpayload,
    pick: ['status', 'message'],
    callback
  };
}

// 绑定手机号
export function bindPhoneNumber(data, { loading = true} = {}, callback) {
  data = {
    check: data.check,
    phone_number: data.phone_number,
    savephone: 1,
    ...data
  }

  var dbpayload = packageDBReq(ACTION.BIND_PHONE_NUMBER, null, data, 'POST', loading);
  return {
    type: ACTION.BIND_PHONE_NUMBER,
    dbpayload,
    pick: ['msg_type', 'msg_detail'],
    callback
  };
}

// 下级转账
export function tranferToMember(data, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.TRANSFER_TO_MEMBER, null, { ...data, flag: 'confirm' }, 'POST', loading);
  return {
    type: ACTION.TRANSFER_TO_MEMBER,
    dbpayload,
    pick: ['msg_type', 'msg_detail', 'sMsg->error', 'ur_here'],
    callback
  };
}

// 领取新手任务奖金
export function getGuideTaskMoney(callback) {
  var dbpayload = packageDBReq(ACTION.GET_GUIDE_TASK_MONEY, null, null, 'GET', true);
  return {
    type: ACTION.GET_GUIDE_TASK_MONEY,
    dbpayload,
    pick: ['status', 'info'],
    callback
  };
}

// 团队统计V2.0
export function getTeamStatisticsV2({ start, end} = {}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_TEAM_STATISTICS_V2, [start, end], null, 'GET', loading);
  return {
    type: ACTION.GET_TEAM_STATISTICS_V2,
    dbpayload,
    callback,
    pick: ['summary', 'summaryExt', 'isContractUser', 'ptGamePie->gameData', 'lotteryPie->lotteryData']
  }
}

// 团队统计V3.0
export function getTeamStatisticsV3({ start, end} = {}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_TEAM_STATISTICS_V3, [start, end], null, 'GET', loading);
  return {
    type: ACTION.GET_TEAM_STATISTICS_V3,
    dbpayload,
    callback,
    pick: ['summary', 'summaryExt', 'isContractUser', 'gameData', 'lotteryData']
  }
}

// 获取彩票分红
export function getLotteryContract({username, cycle_id, pay_status, pageNo, userId }, {loading = true} = {}, callback){
  var dbpayload = packageDBReq(ACTION.GET_LOTTERY_CONTRACT, [username, userId, cycle_id, pay_status, pageNo], null, 'GET', loading);
  return {
    type: ACTION.GET_LOTTERY_CONTRACT,
    dbpayload,
    pick: ['cycles', 'billStatus', 'childrenBill->bills', 'selfBill->self', 'selfPayStatus->payStatus', 'currentCycle', 'setRules->rules', 'children', 'user_notice', 'banCreate', 'banCreatePrompt', 'userNotice'],
    callback
  }
}

// 检查彩票分红详情
export function checkDivident({ userid, flag, cycle_id}, { loading = true} = {}, callback) {
  var data = {
    userid: userid || null,
    flag: flag || null,
    cycle_id
  }
  var dbpayload = packageDBReq(ACTION.CHECK_DIVIDENT, null, data, 'POST', loading);
  return {
    type: ACTION.CHECK_DIVIDENT,
    dbpayload,
    pick: ['data', 'status', 'msg'],
    callback
  };
}

// 发放彩票分红
export function provideDivident({ userid, flag, cycle_id}, { loading = true} = {}, callback) {
  var data = { cycle_id}
  if (userid) {
    data = {
      ...data,
      userid
    };
  }
  if (flag) {
    data = {
      ...data,
      flag
    };
  }
  var dbpayload = packageDBReq(ACTION.PROVIDE_DIVIDENT, null, data, 'POST', loading);
  return {
    type: ACTION.PROVIDE_DIVIDENT,
    dbpayload,
    pick: ['status', 'msg'],
    callback
  };
}

// 查看彩票分红详情
export function checkLotteryDividentDetail({ userid}, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_LOTTERY_CONTRACT_DETAIL, [userid], null, 'GET', loading);
  return {
    type: ACTION.GET_LOTTERY_CONTRACT_DETAIL,
    dbpayload,
    pick: ['data'],
    callback
  }
}

// 创建彩票契约
export function createLotteryContract(request, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.CREATE_LOTTERY_CONTRACT, null, request, 'POST', loading);
  return {
    type: ACTION.CREATE_LOTTERY_CONTRACT,
    dbpayload,
    pick: ['sMsg->message', 'msg_detail->errorMessage'],
    callback
  }
}

// 修改彩票契约
export function updateLotteryContract(request, { loading = true} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.UPDATE_LOTTERY_CONTRACT, null, request, 'POST', loading);
  return {
    type: ACTION.UPDATE_LOTTERY_CONTRACT,
    dbpayload,
    pick: ['sMsg->message', 'msg_detail->errorMessage'],
    callback
  }
}

// 获取团队报表中不同分类数据
export function getTeamStatisticsByType({ type}, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_TEAM_STATISTICS_BY_TYPE, [type], null, 'GET', loading);
  return {
    type: ACTION.GET_TEAM_STATISTICS_BY_TYPE,
    dbpayload,
    pick: ['chart->data'],
    callback
  }
}

// 销毁节点数据
export function destroyNode(nodes) {
  return {
    type: ACTION.DESTROY_NODE,
    nodes
  }
}

// 获取团队报表中不同分类数据2.0
export function getTeamStatisticsByTypeV2({ type, incChild}, { loading = false} = {}, callback) {
  var dbpayload = packageDBReq(ACTION.GET_TEAM_STATISTICS_BY_TYPE_V2, [type, incChild], null, 'GET', loading);
  return {
    type: ACTION.GET_TEAM_STATISTICS_BY_TYPE_V2,
    dbpayload,
    pick: ['chart->data'],
    callback
  }
}
